import queryString from 'query-string';
import {isLocalhost} from '../../utils/utils';
import authService from '../auth/auth.service';

export function getFileUrl(file, options = {}) {

    if (!file) {
        return;
    }

    if (isLocalhost() && authService.userToken) {
        options.t = authService.userToken;
    }

    const qs = queryString.stringify(options);

    // Always on the API host (api.missionx.ai), never the app's own: only the load
    // balancer may reach the API. The session cookie is set on missionx.ai, so it goes
    // with these requests from app.missionx.ai.
    return file.source === "external"
        ? file.path
        : `${process.env.REACT_APP_API_SERVICE_HOST}/drive/d/${file._id}/${encodeURIComponent(file.name)}${qs.length ? '?' + qs : ''}`;
}